// Generate a random pastel color
const generatePastelColor = () => {
  const hue = Math.floor(Math.random() * 360);
  const saturation = Math.floor(Math.random() * 20) + 40; // 40-60% for pastels
  const lightness = Math.floor(Math.random() * 15) + 75; // 75-90% for pastels
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

// Generate a pair of pastel colors for gradient
export const generatePastelGradient = () => {
  const color1 = generatePastelColor();
  const color2 = generatePastelColor();
  return `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`;
};
